export function getView(value) {
  return value.patient_option === 'new' || value.appointment_id
}
